import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface RateLimitLineProps {
  remaining: number | undefined;
  resetAt: number | undefined;
}

const formatResetIn = (t: (k: string, opts?: any) => string, ms: number): string => {
  const seconds = Math.max(0, Math.round(ms / 1000));
  if (seconds < 60) {
    return t("general.assistantScenarIa.rateLimit.resetInSeconds", {
      count: seconds,
    });
  }
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) {
    return t("general.assistantScenarIa.rateLimit.resetInMinutes", {
      count: minutes,
    });
  }
  const hours = Math.round(minutes / 60);
  return t("general.assistantScenarIa.rateLimit.resetInHours", { count: hours });
};

export const RateLimitLine = ({ remaining, resetAt }: RateLimitLineProps) => {
  const { t } = useTranslation();

  // Refresh roughly every 10s so the countdown stays fresh.
  const [, tick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => tick((n) => n + 1), 10000);
    return () => window.clearInterval(id);
  }, []);

  if (typeof remaining !== "number" || remaining > 3 || remaining < 0) {
    // Reserve space to avoid layout shift when it flips visible later.
    return <div className="h-4 mt-1" aria-hidden="true" />;
  }

  const resetIn =
    typeof resetAt === "number" ? formatResetIn(t as any, Math.max(0, resetAt - Date.now())) : null;

  return (
    <div className="text-[10px] text-amber-600 mt-1" role="status">
      {resetIn
        ? t("general.assistantScenarIa.rateLimit.warning", {
            count: remaining,
            resetIn,
          })
        : t("general.assistantScenarIa.rateLimit.warningNoReset", {
            count: remaining,
          })}
    </div>
  );
};

export default RateLimitLine;
